
export const deliveryListColumns = [
    'deliveryAddress',
    'client',
    'isConfirmed',
    'created',
    'modified',
] as const;
export type DeliveryColumnKey = typeof deliveryListColumns[number];

export type DeliveryColumnSortOrder = {
    column: DeliveryColumnKey;
    order: 'asc' | 'desc' | null;
}[];

export interface DeliveryListItem {
    uuid: string;
    externalId: string | null;
    deliveryAddress: string;
    client: string;
    clientEmail: string;
    clientPhone: string;
    documentId: string;
    isConfirmed: boolean;
    driverNote: string;
    created: Date;
    modified: Date;
}

export interface DeliveryRequestParams {
    userId: number;
    appVersion: string;
    sort: DeliveryColumnSortOrder;
    filters: {
        notConfirmed: boolean | null;
    };
    offset: number;
    limit: number;
};